;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React, { useState } from 'react';
import { Input, Label, Button, ListGroupItem, Collapse } from 'reactstrap';

import { MdExpandMore } from 'react-icons/md';

import { useParams, useRouter, useSearchParams } from 'next/navigation';

import querystring from 'query-string';
import { xor } from 'lodash';
import capitalizeFirstLetter from '../utils/capitalizeFirstLetter';
import { Dictionaries, Locale } from '../i18n/i18n-config';
import { FacetCount, FacetGroupName, facetGroupNames } from '../api/jobs';

function FacetFilter({
  facetGroup,
  facets,
  dictionary,
  open: defaultOpen,
}: {
  dictionary: Partial<Dictionaries>;
  facets: FacetCount[];
  facetGroup: FacetGroupName;
  open?: boolean;
}) {
  const searchParams = useSearchParams();
  const { push } = useRouter();
  const { locale } = useParams<{ locale: Locale }>();
  const activeFacets = searchParams.getAll(facetGroup);

  const [open, setOpen] = useState(!!defaultOpen);
  const toggleOpen = () => setOpen((prev) => !prev);

  const [showAll, setShowAll] = useState(false);
  const toggleShowAll = () => setShowAll((prev) => !prev);

  const vacancyParams: Partial<Record<FacetGroupName, string[]>> = {};
  facetGroupNames.forEach((param) => (vacancyParams[param] = searchParams?.getAll(param)));

  if (!facets) return null;

  let facetGroupTranslation;
  switch (facetGroup) {
    case 'contractTypes':
      facetGroupTranslation = 'jobs-contract-type-facet-title';
      break;
    case 'division':
      facetGroupTranslation = 'jobs-division-facet-title';
      break;
    case 'experiences':
      facetGroupTranslation = 'jobs-experience-facet-title';
      break;
    case 'jobDomains':
      facetGroupTranslation = 'jobs-sector-facet-title';
      break;
    case 'laborRegimes':
      facetGroupTranslation = 'jobs-labor-regime-facet-title';
      break;
    case 'locations':
      facetGroupTranslation = 'jobs-location-facet-title';
      break;
    case 'shifts':
      facetGroupTranslation = 'jobs-shifts-facet-title';
      break;
    case 'workPlaceType':
      facetGroupTranslation = 'jobs-work-place-type-facet-title';
      break;
    default:
      break;
  }

  if (!dictionary[facetGroupTranslation]) {
    console.error(`no translation for facet ${facetGroup}, skipping render`);
    return null;
  }

  const renderFacetItem = ({ id, name, count }: FacetCount, i: number) => {
    const facetTranslation = facetGroup === 'locations' ? id : dictionary[id];
    return (
      <li key={`facet_checkbox_${facetGroup}_${name}`} className="list-unstyled">
        <Input
          className="align-top me-0"
          type="checkbox"
          name={`${facetGroup}_${i}_${name}`}
          id={`${facetGroup}_${i}_${name}`}
          onChange={() => {
            vacancyParams[facetGroup] = xor(vacancyParams[facetGroup], [name]);
            push(`/${locale}/jobs/?${querystring.stringify({ ...vacancyParams, page: 1 })}`);
          }}
          checked={!!(activeFacets && activeFacets.indexOf(name.toString()) !== -1)}
        />
        <Label className="ps-2" for={`${facetGroup}_${i}_${name}`}>
          {capitalizeFirstLetter(facetTranslation)} {count && `(${count})`}
        </Label>
      </li>
    );
  };

  return (
    <ListGroupItem className={`p-0 p-lg-3 mb-3 border facetFilter ${open ? 'open' : 'closed'}`}>
      <Button
        className="collapse-toggle d-flex align-items-center justify-content-between px-0 pb-3 border-bottom no-border-bottom-lg"
        tag="h3"
        color="white"
        onClick={toggleOpen}
      >
        <span>{capitalizeFirstLetter(dictionary[facetGroupTranslation])}</span>
        <MdExpandMore size="20" color="black" />
      </Button>
      <Collapse isOpen={open} tag="ul" className="px-3 px-lg-0">
        {facets && facets.slice(0, 10).map(renderFacetItem)}
        {facets && facets.length > 10 && (
          <li className="list-unstyled facet-show-more-wrapper">
            <Collapse isOpen={showAll} tag="ul" className="ps-0 list-unstyled">
              {facets.slice(10).map((facet, i) => renderFacetItem(facet, i + 10))}
            </Collapse>
            <Button className="facet-show-more px-0 py-2" color="link" onClick={toggleShowAll}>
              <span>{dictionary[showAll ? 'jobs-facet-show-less' : 'jobs-facet-show-more']}</span>
              <MdExpandMore size="16" color="black" style={{ transform: showAll ? 'rotate(180deg)' : 'none' }} />
            </Button>
          </li>
        )}
      </Collapse>
    </ListGroupItem>
  );
}

export default FacetFilter;
